module.exports = __webpack_public_path__ + "static/media/groupIcon.da268e7f.svg";